/* unplugin-vue-components disabled */import { render } from "./CustomerQuery2Cpt.vue?vue&type=template&id=97617de2"
import script from "./CustomerQuery2Cpt.vue?vue&type=script&lang=js"
export * from "./CustomerQuery2Cpt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__